import Link from 'antd/es/typography/Link'
import { AIChatCitationFragment } from 'types/graphql'

import { ExternalLinkProps } from 'src/constants'

type Props = {
  citation: AIChatCitationFragment
}

export const Citation = ({ citation }: Props) => {
  if (citation.aiTrainingMaterial) {
    if (citation.aiTrainingMaterial.file?.url?.signedUrl) {
      return (
        <Link href={citation.aiTrainingMaterial.file.url.signedUrl} {...ExternalLinkProps}>
          {citation.aiTrainingMaterial.file.name}
        </Link>
      )
    }
    return 'Training material'
  }
  if (citation.scrapedFile) {
    return (
      <Link href={citation.scrapedFile.sourceUrl} {...ExternalLinkProps}>
        {citation.scrapedFile.sourceUrl}
      </Link>
    )
  }
  if (citation.codeBookItem) {
    return [citation.codeBookItem.codeBook?.name, citation.codeBookItem.formattedName]
      .filter(Boolean)
      .join(' - ')
  }
  if (citation.violationCode) {
    return `${citation.violationCode.corpus} §${citation.violationCode.sectionName} (
        ${citation.violationCode.title})`
  }
  return null
}
